import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.vehicleOperator.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.vehicleOperator.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.vehicleOperator.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.vehicleOperator.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.vehicleOperator.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addX: {
        id: 'ml.policychange.vehicleOperator.Add x',
        defaultMessage: 'Add {driverType}'
    },
    editX: {
        id: 'ml.policychange.vehicleOperator.Edit x',
        defaultMessage: 'Edit {driverType}'
    },
    removeX: {
        id: 'ml.policychange.vehicleOperator.Remove x',
        defaultMessage: 'Remove {driverName}'
    },
    removeHouseholdMember: {
        id: 'ml.policychange.vehicleOperator.Remove household member',
        defaultMessage: 'Remove household member'
    },
    removeNonDriver: {
        id: 'ml.policychange.vehicleOperator.Remove Non Driver',
        defaultMessage: 'Remove Non Driver'
    },
    removeExcludedDriver: {
        id: 'ml.policychange.vehicleOperator.Remove excluded driver',
        defaultMessage: 'Remove excluded driver'
    },
    addDetailsForThisDriver: {
        id: 'ml.policychange.vehicleOperator.Please add the details for your new driver below',
        defaultMessage: 'Please add the details for your new driver below'
    },
    updateDetailsForThisDriver: {
        id: 'ml.policychange.vehicleOperator.Please update the details for this driver below',
        defaultMessage: 'Please update the details for this driver below'
    },
    reasonForRemovingX: {
        id: 'ml.policychange.vehicleOperator.Reason for removing x',
        defaultMessage: 'Reason for removing {name}'
    },
    driver: {
        id: 'ml.policychange.vehicleOperator.Driver',
        defaultMessage: 'Driver'
    },
    drivers: {
        id: 'ml.policychange.vehicleOperator.Drivers',
        defaultMessage: 'Drivers'
    },
    excludedDriver: {
        id: 'ml.policychange.vehicleOperator.Excluded Driver',
        defaultMessage: 'Excluded Driver'
    },
    excludedDrivers: {
        id: 'ml.policychange.vehicleOperator.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    householdMember: {
        id: 'ml.policychange.vehicleOperator.Household Member',
        defaultMessage: 'Household Member'
    },
    householdMembers: {
        id: 'ml.policychange.vehicleOperator.Household Members',
        defaultMessage: 'Household Members'
    },
    nonDriver: {
        id: 'ml.policychange.vehicleOperator.Non Driver',
        defaultMessage: 'Non Driver'
    },
    nonDrivers: {
        id: 'ml.policychange.vehicleOperator.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    excludedMember: {
        id: 'ml.policychange.vehicleOperator.Excluded Member',
        defaultMessage: 'Excluded Member'
    },
    excludedMembers: {
        id: 'ml.policychange.vehicleOperator.Excluded Members',
        defaultMessage: 'Excluded Members'
    },
    whatIsSecondaryNamedInsured: {
        id: 'ml.policychange.vehicleOperator.What is a secondary named insured',
        defaultMessage: 'What is a secondary named insured?'
    },
    definitionOfSecondaryNamedInsured: {
        id: 'ml.policychange.vehicleOperator.defination of secondary named insured',
        defaultMessage: 'A secondary named insured is typically the person who is co-titled on a vehicle or co-owner on a property deed. They have the same coverage under the policy as the named insured.'
    },
    notAValidReasonToRemovePrimaryNamedInsured: {
        id: 'ml.policychange.vehicleOperator.The reason selected is not a valid reason to remove the named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to remove the named insured. We require this person to be listed.'
    },
    notAValidReasonToExcludeSecondaryNamedInsured: {
        id: 'ml.policychange.vehicleOperator.The reason selected is not a valid reason to exclude the secondary named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to exclude the secondary named insured. We require this person to be listed.'
    },
    notAValidReasonToRemoveSecondaryInsured: {
        id: 'ml.policychange.vehicleOperator.The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed.'
    },
    notAValidReasonToRemoveExclusion: {
        id: 'ml.policychange.vehicleOperator.The reason selected is not a valid reason to remove the exclusion',
        defaultMessage: 'The reason selected is not a valid reason to remove the exclusion.'
    },
    weRequireThisDriverToBeExcluded: {
        id: 'ml.policychange.vehicleOperator.We require this driver to be excluded as their license is suspended or revoked',
        defaultMessage: 'We require this driver to be excluded as their license is suspended or revoked.'
    },
    notAValidReasonToRemoveThisDriver: {
        id: 'ml.policychange.vehicleOperator.The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.'
    },
    spouseCanNotBeExcluded: {
        id: 'ml.policychange.vehicleOperator.If licensed, the spouse can not be excluded from the policy',
        defaultMessage: 'If licensed, the spouse can not be excluded from the policy.'
    },
    spouseCanNotBeRemoved: {
        id: 'ml.policychange.vehicleOperator.Spouse cannot be removed as a driver if licensed',
        defaultMessage: 'Spouse cannot be removed as a driver if licensed'
    },
    driverMustBeRatedOrExcluded: {
        id: 'ml.policychange.vehicleOperator.The driver must be either rated or excluded on this policy',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    driverExclusionHelpText: {
        id: 'ml.policychange.vehicleOperator.Driver Exclusion Help Text',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver. If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    spouseWasAlreadySelected: {
        id: 'ml.policychange.vehicleOperator.Spouse was already selected as a relationship to insured on another driver',
        defaultMessage: 'Spouse was already selected as a relationship to insured on another driver.'
    },
    selfWasAlreadySelected: {
        id: 'ml.policychange.vehicleOperator.Self has already been selected as a relationship to insured on another driver.',
        defaultMessage: 'Self has already been selected as a relationship to insured on another driver.'
    },
    addHouseholdMember: {
        id: 'ml.policychange.vehicleOperator.Add Household Member',
        defaultMessage: 'Add Household Member'
    },
    editHouseholdMember: {
        id: 'ml.policychange.vehicleOperator.Edit Household Member',
        defaultMessage: 'Edit Household Member'
    },
    saveAddHouseholdMemberWarning: {
        id: 'ml.policychange.vehicleOperator.An error has occurred which may prevent you from completing your quote. If you are unable to continue past this page, please contact customer service for assistance using the chat feature.',
        defaultMessage: 'An error has occurred which may prevent you from completing your quote. If you are unable to continue past this page, please contact customer service for assistance using the chat feature.'
    }

});
